import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { useSearchParams } from "routes/hooks";

import {
  ForgotPasswordManager,
  SignInForm,
  SignUpForm,
  SignUpInvitation,
  VerificationCodeForm,
} from "scenes/Authentication/components";

function AuthenticationRoutes() {
  const { path } = useRouteMatch();
  const [searchParams] = useSearchParams();

  return (
    <Switch>
      <Route path={`${path}/login`}>
        <SignInForm />
      </Route>

      <Route exact path={`${path}/signup/:advisorId`}>
        <SignUpInvitation />
      </Route>

      <Route path={`${path}/signup`}>
        <SignUpForm email={searchParams.email} />
      </Route>

      <Route path={`${path}/forgot-password`}>
        <ForgotPasswordManager />
      </Route>

      <Route path={`${path}/confirm/:email`}>
        <VerificationCodeForm />
      </Route>

      <Route>
        <Redirect to={`${path}/login`} />
      </Route>
    </Switch>
  );
}

export default AuthenticationRoutes;
